import cx from 'classnames'
import useKeyboardNavigation from 'hooks/useKeyboardNavigation'
import React, { useEffect, useRef } from 'react'

import './style.css'

export default function Input({
  className = "",
  shouldFocus = true,
  ...rest
}) {
  const inputRef = useRef<HTMLInputElement>()
  const isInputFocused = useKeyboardNavigation(inputRef)

  useEffect(() => {
    if (inputRef.current && shouldFocus) {
      inputRef.current.focus()
    }
  }, [shouldFocus])

  return (
    <input
      className={cx("drift-widget-input js-focus-visible--controlled", {
        [className]: !!className,
        'keyboard-focused': isInputFocused,
      })}
      ref={inputRef}
      {...rest}
    />
  )
}
